import React from "react";
import {
  Container,
  Box,
  Grow,
  Typography,
  Fade,
  Grid,
  Zoom,
  Avatar,
  Chip,
  alpha,
} from "@mui/material";
import {
  // ShoppingCart,
  // RocketLaunch,
  // Timeline,
  // History,
  // Inventory2,
  // Assessment,
    RocketLaunch,
  SyncAlt,
  PhoneAndroid,
  Security,
  HeadsetMic,
  TrendingUp
} from "@mui/icons-material";
import { styled, keyframes } from "@mui/material/styles";

const FeatureCard = styled(Box)(({ theme }) => ({
  background: "rgba(37, 211, 102, 0.05)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(37, 211, 102, 0.1)",
  borderRadius: 20,
  padding: theme.spacing(3),
  transition: "all 0.3s",
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-8px)",
    borderColor: "#25D366",
    boxShadow: "0 10px 30px rgba(37, 211, 102, 0.15)",
    background: "rgba(37, 211, 102, 0.08)",
  },
}));

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const GradientText = styled("span")(({ theme }) => ({
  background: "linear-gradient(135deg, #2E9E53 0%, #25D366 50%, #0B4064 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "inherit",
  backgroundSize: "200% 200%",
  animation: `${shimmer} 3s ease-in-out infinite`,
}));

const DealersLove = () => {
  // const features = [
  //   {
  //     icon: <ShoppingCart sx={{ fontSize: 40 }} />,
  //     title: '24/7 Ordering',
  //     desc: 'Place orders anytime, anywhere with our mobile app',
  //     color: '#25D366'
  //   },
  //   {
  //     icon: <Timeline sx={{ fontSize: 40 }} />,
  //     title: 'Real-time Tracking',
  //     desc: 'Complete visibility of your orders and inventory',
  //     color: '#128C7E'
  //   },
  //   {
  //     icon: <RocketLaunch sx={{ fontSize: 40 }} />,
  //     title: 'Fast Processing',
  //     desc: 'Instant order confirmation and faster payments',
  //     color: '#075E54'
  //   },

  //   {
  //     icon: <History sx={{ fontSize: 40 }} />,
  //     title: 'Invoice History',
  //     desc: 'Access all past invoices anytime, anywhere',
  //     color: '#25D366'
  //   },
  //   {
  //     icon: <Payment sx={{ fontSize: 40 }} />,
  //     title: 'Secure Payments',
  //     desc: 'Multiple payment options with instant settlement',
  //     color: '#128C7E'
  //   },
  //   {
  //     icon: <Speed sx={{ fontSize: 40 }} />,
  //     title: 'Fast Delivery',
  //     desc: 'Priority delivery for app orders',
  //     color: '#075E54'
  //   }
  // ];

  // const features = [
  //   {
  //     icon: <ShoppingCart sx={{ fontSize: 40 }} />,
  //     // title: "24/7 Ordering",
  //     title: "Fast Deployment",
  //     // desc: "Place orders anytime, anywhere with our mobile app",
  //     desc: "Go live in as little as 15 days — from scoping to production-ready software.",
  //     color: "#25D366",
  //   },
  //   {
  //     icon: <Timeline sx={{ fontSize: 40 }} />,
  //     // title: "Real-time Tracking",
  //     title:"Seamless Integrations",
  //     // desc: "Complete visibility of your orders and inventory",
  //     desc: "Tally, SAP, Zoho, and custom ERPs — we connect your existing systems effortlessly.",
  //     // desc: "Complete visibility of your orders and inventory",
  //     color: "#128C7E",
  //   },
  //   {
  //     icon: <RocketLaunch sx={{ fontSize: 40 }} />,
  //     // title: "Fast Processing",
  //     title:"Mobile-First Architecture",
  //     // desc: "Instant order confirmation and faster processing",
  //     desc:"Built for India's distribution networks — fast, offline-ready, and field-friendly.",
  //     color: "#075E54",
  //   },
  //   {
  //     icon: <History sx={{ fontSize: 40 }} />,
  //     // title: "Invoice History",
  //     title:"Reliable & Scalable",
  //     // desc: "Access all past invoices anytime, anywhere",
  //     desc:"Enterprise-grade infrastructure for businesses of all sizes, built to scale with you.",
  //     color: "#25D366",
  //   },
  //   {
  //     icon: <Inventory2 sx={{ fontSize: 40 }} />, // 👈 new icon
  //     // title: "Live Catalog & Pricing",
  //     title:"Dedicated Support",
  //     // desc: "Get real-time product catalog updates with latest pricing",
  //     desc:"A real team behind your product, always. Not a ticket queue — a tech partner.",
  //     color: "#128C7E",
  //   },
  //   // {
  //   //   icon: <Assessment sx={{ fontSize: 40 }} />, // 👈 new icon
  //   //   title: "Interest Report",
  //   //   desc: "Track outstanding balances and interest reports easily",
  //   //   color: "#075E54",
  //   // },
  //   // {
  //   //   icon: <ReceiptLong sx={{ fontSize: 40 }} />, // 👈 new icon
  //   //   title: "Order Management",
  //   //   desc: "Manage, update and track all orders in one place",
  //   //   color: "#25D366",
  //   // },
  // ];

    const features = [
    {
      icon: <RocketLaunch sx={{ fontSize: 40 }} />,
      title: "Fast Deployment",
      // desc: "Go live in as little as 15 days — from scoping to production-ready software.",
      desc:"Launch your business platform quickly with a streamlined development process and production-ready delivery.",
      color: "#25D366",
    },
    {
      icon: <SyncAlt sx={{ fontSize: 40 }} />,
      title: "Seamless Integrations",
      // desc: "Tally, SAP, Zoho, and custom ERPs — we connect your existing systems effortlessly.",
      desc:"Easily integrate with your existing business tools, third-party platforms, and enterprise systems for smooth operations.",
      color: "#128C7E",
    },
    {
      icon: <PhoneAndroid sx={{ fontSize: 40 }} />,
      title: "Mobile-First Architecture",
      // desc: "Built for India's distribution networks — fast, offline-ready, and field-friendly.",
      desc:"Designed for modern businesses with responsive, high-performance, and user-friendly mobile experiences.",
      color: "#075E54",
    },
    {
      icon: <Security sx={{ fontSize: 40 }} />,
      title: "Reliable & Scalable",
      desc: "Enterprise-grade infrastructure for businesses of all sizes, built to scale with you.",
      color: "#25D366",
    },
    {
      icon: <HeadsetMic sx={{ fontSize: 40 }} />,
      title: "Dedicated Support",
      desc: "A real team behind your product, always. Not a ticket queue — a tech partner.",
      color: "#128C7E",
    },
    {
      icon: <TrendingUp sx={{ fontSize: 40 }} />,
      title: "Business Growth",
      desc: "Data-driven insights to help your business grow and scale efficiently.",
      color: "#075E54",
    },
  ];

  return (
    <>
      <Box
        sx={{
          bgcolor: "#0A1929",
          minHeight: "100vh",
          color: "white",
          position: "relative",
          overflow: "hidden",
          // mt:7
        }}
      >
        <Container maxWidth="lg" sx={{ py: 10 }}>
          <Box sx={{ textAlign: "center", mb: 8 }}>

                <Grow in timeout={800}>
                          <Chip
                            // icon={<RocketLaunch />}
                            // label="POWERFUL FEATURES"
                            label="Why BizBridge"
                            sx={{
                              bgcolor: alpha("#2E9E53", 0.1),
                              color: "#2E9E53",
                              fontWeight: 800,
                              mb: 3,
                              px: 3,
                              py: 2.5,
                              fontSize: "0.9rem",
                              border: `1px solid ${alpha("#2E9E53", 0.3)}`,
                              "& .MuiChip-icon": { color: "#2E9E53" },
                            }}
                          />
                        </Grow>

            <Zoom in timeout={1000}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  color: "#FFF",
                  fontFamily: "'Archivo Black', sans-serif",
                  fontSize: {
                    xs: "1.8rem",
                    sm: "2.2rem",
                    md: "3rem",
                    lg: "3.5rem",
                  },
                  lineHeight: 1.2,
                  mb: { xs: 1.5, md: 2 },
                }}
              >
                {/* Why Dealers <GradientText>Love us</GradientText> */}
                Why Businesses Choose <GradientText>BizBridge</GradientText> 
              </Typography>
            </Zoom>
            <Fade in timeout={1500}>
              <Typography
                variant="h6"
                sx={{ color: "#B2B9C5", maxWidth: 700, mx: "auto" }}
              >
                {/* Everything you need to grow your business in one powerful app */}
                We don't sell off-the-shelf software. We understand B2B operations deeply and engineer solutions that grow with your business.
              </Typography>
            </Fade>
          </Box>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Zoom in timeout={500 + index * 200}>
                  <FeatureCard>
                    <Avatar
                      sx={{
                        width: 70,
                        height: 70,
                        bgcolor: "rgba(37, 211, 102, 0.1)",
                        color: feature.color,
                        margin: "0 auto 20px",
                        border: `2px solid ${feature.color}`,
                      }}
                    >
                      {feature.icon}
                    </Avatar>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography sx={{ color: "#B2B9C5", textAlign: "center" }}>
                      {feature.desc}
                    </Typography>
                  </FeatureCard>
                </Zoom>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default DealersLove;
